import React, { useState } from 'react';
import './BecomeDistributorPage.css';
import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const countryList = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan',
  'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi',
  'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo, Democratic Republic of the', 'Congo, Republic of the', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia',
  'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary',
  'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
  'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Macedonia', 'Norway',
  'Oman',
  'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
  'Qatar',
  'Romania', 'Russia', 'Rwanda',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
  'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
  'Yemen',
  'Zambia', 'Zimbabwe'
];

const yearsList = [
  'Less than 1 year', '1-3 years', '3-5 years', '5+ years'
];

const BecomeDistributorPage = () => {
  const [form, setForm] = useState({
    company: '', website: '', name: '', email: '', phone: '', country: '', city: '',
    distributes: '', brands: '', years: '', why: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => {
    const { name, value, type } = e.target;
    setForm(f => ({ ...f, [name]: type === 'radio' ? value : value }));
    // Clear any previous errors when user makes changes
    if (error) setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Add timestamp and status to the form data
      const formData = {
        ...form,
        status: 'pending',
        submittedAt: serverTimestamp()
      };

      // Add the document to the 'distributor-applications' collection
      await addDoc(collection(db, 'distributor-applications'), formData);
      
      setSubmitted(true);
      setForm({
        company: '', website: '', name: '', email: '', phone: '', country: '', city: '',
        distributes: '', brands: '', years: '', why: ''
      });
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="distributor-main">
      <section className="distributor-hero">
        <h1>🤝 Become a Distributor</h1>
        <p>Want to represent Derma Protec in your country? Partner with us to bring premium window film technology to your region. We're actively looking for exclusive distributors with a passion for quality and growth.</p>
      </section>
      <section className="distributor-form-section">
        <img 
          src="https://i.postimg.cc/htGX5zF4/about-us-derma-car.png" 
          alt="Professional business meeting" 
          style={{ maxWidth: '480px', width: '100%', height: 'auto', display: 'block', margin: '0 auto 32px auto', borderRadius: '12px', boxShadow: '0 2px 12px rgba(53,159,149,0.10)' }}
        />
        <h2>📝 Apply to Become a Derma Protec Distributor</h2>
        {submitted ? (
          <div className="distributor-success">
            Thank you for your application! We will review your submission and contact you soon.
          </div>
        ) : (
          <>
            {error && <div className="distributor-error">{error}</div>}
            <form className="distributor-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <label><span className="label-row">Company Name <span className="required">*</span></span>
                  <input 
                    name="company" 
                    value={form.company} 
                    onChange={handleChange} 
                    required 
                    placeholder="Your Business Name"
                    disabled={loading}
                  />
                </label>
                <label><span className="label-row">Website</span>
                  <input 
                    name="website" 
                    value={form.website} 
                    onChange={handleChange} 
                    placeholder="www.yourbusiness.com"
                    disabled={loading}
                  />
                </label>
              </div>

              <div className="form-row">
                <label><span className="label-row">Full Name <span className="required">*</span></span>
                  <input 
                    name="name" 
                    value={form.name} 
                    onChange={handleChange} 
                    required 
                    placeholder="First & Last Name"
                    disabled={loading}
                  />
                </label>
                <label><span className="label-row">Email Address <span className="required">*</span></span>
                  <input 
                    name="email" 
                    type="email" 
                    value={form.email} 
                    onChange={handleChange} 
                    required 
                    placeholder="example@example.com"
                    disabled={loading}
                  />
                </label>
              </div>

              <div className="form-row">
                <label><span className="label-row">Phone Number <span className="required">*</span></span>
                  <input 
                    name="phone" 
                    value={form.phone} 
                    onChange={handleChange} 
                    required 
                    placeholder="+123456789"
                    disabled={loading}
                  />
                </label>
                <label><span className="label-row">Country of Operation <span className="required">*</span></span>
                  <select 
                    name="country" 
                    value={form.country} 
                    onChange={handleChange} 
                    required
                    disabled={loading}
                  >
                    <option value="">Select Country</option>
                    {countryList.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </label>
              </div>

              <div className="form-row">
                <label><span className="label-row">City / Region <span className="required">*</span></span>
                  <input 
                    name="city" 
                    value={form.city} 
                    onChange={handleChange} 
                    required 
                    placeholder="Your City"
                    disabled={loading}
                  />
                </label>
                <label><span className="label-row">How many years have you been in operation? <span className="required">*</span></span>
                  <select 
                    name="years" 
                    value={form.years} 
                    onChange={handleChange} 
                    required
                    disabled={loading}
                  >
                    <option value="">Select</option>
                    {yearsList.map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                </label>
              </div>

              <label><span className="label-row">Do you currently distribute any automotive or architectural products? <span className="required">*</span></span></label>
              <div className="distributor-radio-group">
                <label><span className="label-row">Yes <span className="required">*</span></span>
                  <input 
                    type="radio" 
                    name="distributes" 
                    value="Yes" 
                    checked={form.distributes === 'Yes'} 
                    onChange={handleChange} 
                    required
                    disabled={loading}
                  />
                </label>
                <label><span className="label-row">No <span className="required">*</span></span>
                  <input 
                    type="radio" 
                    name="distributes" 
                    value="No" 
                    checked={form.distributes === 'No'} 
                    onChange={handleChange} 
                    required
                    disabled={loading}
                  />
                </label>
              </div>

              {form.distributes === 'Yes' && (
                <label><span className="label-row">If yes, please list the brands or products: <span className="required">*</span></span>
                  <textarea 
                    name="brands" 
                    value={form.brands} 
                    onChange={handleChange} 
                    required
                    placeholder="List brands or products"
                    disabled={loading}
                  />
                </label>
              )}

              <label><span className="label-row">Why do you want to distribute Derma Protec Films? <span className="required">*</span></span>
                <textarea 
                  name="why" 
                  value={form.why} 
                  onChange={handleChange} 
                  required
                  placeholder="Tell us about your interest and market potential" 
                  disabled={loading}
                />
              </label>

              <button 
                className="distributor-btn" 
                type="submit"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Apply Now'}
              </button>
            </form>
          </>
        )}
      </section>
    </main>
  );
};

export default BecomeDistributorPage; 